import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import {
  homeContentInnerSx,
  homeContentShellSx,
  providerShellHeroShellSx,
  providerShellHeroSx,
} from '@/features/home/styles/homeStyles'
import { ACCOUNT_PAGE_MAX_WIDTH } from '@/features/account/lib/account-settings-tokens'

export function AccountPageSkeleton() {
  return (
    <Box data-testid="account-page-skeleton" aria-busy aria-label="Loading account settings">
      <Box sx={providerShellHeroSx}>
        <Box sx={providerShellHeroShellSx}>
          <Box sx={homeContentInnerSx}>
            <Skeleton variant="text" width={180} height={40} />
            <Skeleton variant="text" width={220} height={24} sx={{ mt: 1 }} />
          </Box>
        </Box>
      </Box>
      <Box sx={homeContentShellSx}>
        <Box sx={{ ...homeContentInnerSx, maxWidth: ACCOUNT_PAGE_MAX_WIDTH }}>
          <Skeleton variant="text" width={160} height={36} sx={{ mt: { xs: 3, md: '25px' }, mb: '8px' }} />
          <Skeleton variant="text" width={280} height={21} sx={{ mb: { xs: 3, md: '24px' } }} />
          <Box sx={{ display: 'flex', gap: '7px', borderBottom: '1px solid #e4e9f0', pt: '4px', minHeight: 48, mb: 0 }}>
            <Skeleton variant="rounded" width={178} height={42} sx={{ borderRadius: '8px 8px 0 0', mb: '-1px' }} />
            <Skeleton variant="text" width={130} height={22} sx={{ alignSelf: 'center', ml: 1 }} />
          </Box>
          <Skeleton variant="rounded" height={520} sx={{ borderRadius: '0 0 15px 15px' }} />
        </Box>
      </Box>
    </Box>
  )
}
